import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();

  const handleLegalPageClick = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
      <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>WeLegal</h3>
            <p>Making legal support more accessible, transparent, and client-focused.</p>
            <div className="social-links">
              <a href="https://facebook.com/welegal" aria-label="Facebook"><i className="fab fa-facebook"></i></a>
              <a href="https://twitter.com/welegal" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="https://linkedin.com/company/welegal" aria-label="LinkedIn"><i className="fab fa-linkedin"></i></a>
              <a href="https://instagram.com/welegal" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
            </div>
          </div>
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="/#services">Civil Law</a></li>
              <li><a href="/#services">Criminal Law</a></li>
              <li><a href="/#services">Matrimonial</a></li>
              <li><a href="/#services">Arbitration</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><a href="/#about">About Us</a></li>
              <li><a href="/#contact">Contact</a></li>
              <li><a onClick={() => handleLegalPageClick('/privacy-policy')} className="footer-link" style={{cursor: 'pointer'}}>Privacy Policy</a></li>
              <li><a onClick={() => handleLegalPageClick('/terms-conditions')} className="footer-link" style={{cursor: 'pointer'}}>Terms of Service</a></li>
            </ul>
          </div>
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p><i className="fas fa-phone"></i> +91 9999999999</p>
            <p><i className="fas fa-envelope"></i> info@welegal.co</p>
            <p><i className="fas fa-map-marker-alt"></i> Delhi NCR</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; 2024 WeLegal. All rights reserved.</p>
          <p className="developed-by">
            Developed and maintained by 
            <a href="https://proctur.com" target="_blank" rel="noopener noreferrer" className="proctur-link">
              <i className="fas fa-code"></i>
              proctur.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;